import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/sidebarLayout.css";
import { TbListDetails, TbLogout, TbSettings2, TbHistory, TbHistoryToggle } from "react-icons/tb";
import { useLocation } from "react-router-dom";
import UserDetails from "../pages/UserDetails.js"
import KycStatus from "../pages/KycStatus.js";
import AdminSettings from "./adminSettings.js";
import UserWallet from "./userWalletData.js"
import ReferralStatus from "./referralStatus.js"
import TransactionHistory from "./Transaction.js"
import AdminHistory from "./adminTransferHistory.js"
import { GrClose } from "react-icons/gr";
import render1 from "../assets/Image/willgrowlogo.png";
import $ from "jquery";
import { makeApiRequest } from "../axiosService/apiCall.js";
import Error from "./Error.js";
import Adminmanual from "./Adminmanual.js";
import KYCdetails from "./ KYCdetails.js";
import Withdrawrequest from "./Withdrawrequest.js";
import Rewardranking from "./Rewardranking.js";
import Planreward from "./Planreward.js";
import AdminmanualTransferHistory from "./adminmanualtransfer.js"
import Adminwallet from "./Adminwallet.js";
import ClaimHistory from "./ClaimHistory.js";
import { BiSolidUserDetail } from "react-icons/bi";
import { SiInstatus } from "react-icons/si";
import { SiWalletconnect } from "react-icons/si";
import { FaCodePullRequest } from "react-icons/fa6";
import { BiTransfer } from "react-icons/bi";
import { FaMedal } from "react-icons/fa";
import { GrUserSettings } from "react-icons/gr";
import { MdManageHistory } from "react-icons/md";
import { FaRegPaperPlane } from "react-icons/fa";
import { PiMedalMilitaryBold } from "react-icons/pi";
import { PiMedalMilitary } from "react-icons/pi";
import Userstakedetails from './UserStakeDetails.js'
// import Texawallet from "./Texawallet.js";
import RestakePlan from "./RestakePlan.js";
import Userincomehistory from "./Userincomehistory.js";
import Viewhistory from "./Viewhistory.js";
import RestakeRequest from "./RestakeRequest.js";
import Usertransferwallet from "./Usertransferwallet.js";
import Adminclaimhistory from "./Adminclaimhistory.js";
import AdminReferralStatus from "./AdminReferal.js";


function SidebarLayout() {
  const location = useLocation();
  const [admin, setAdmin] = useState({});


  $(document).ready(function () {
    if ($(window).width() < 600) {
      // if width is less than 600px
      $(".nav-link").click(function () {
        $("#mySidenav").css("width", "0px");
      });
    } else {
      // $('#v-pills-asset-tab').click(function () {
      //   location.reload();
      // });
    }

    $("#mobile-three-line-collapse").click(function () {
      $("#mySidenav").css("width", "250px");
    });
    $("#mobile-close-collapse").click(function () {
      $("#mySidenav").css("width", "0px");
    });
    $(".dashboard-profile-table-tabs-section-hide").hide();
    $(".details-button-navigation button").click(function () {
      $(".dashboard-profile-section-hide").hide();
      $(".dashboard-profile-table-tabs-section-hide").show();
      $("#mySidenav").css("width", "100px");
      $(".dashboard-main-section").css("margin-left", "100px");
      $(".dashboard-navbar-brand img").css("width", "50px");
      $(".dashboard-navbar-brand img").css("height", "50px");
      $("#mobile-close-arrow-left").hide();
      $(".dashboard-text-1").hide();
      $("#mobile-close-arrow-right").show();
    });
    $(".button-dashboard-table-back").click(function () {
      $(".dashboard-profile-section-hide").show();
      $(".dashboard-profile-table-tabs-section-hide").hide();
      $("#mySidenav").css("width", "250px");
      $(".dashboard-main-section").css("margin-left", "250px");
      $(".dashboard-navbar-brand img").css("width", "80px");
      $(".dashboard-navbar-brand img").css("height", "80px");
      $("#mobile-close-arrow-left").show();
      $(".dashboard-text-1").show();
      $("#mobile-close-arrow-right").hide();
    });

    $("#mobile-close-arrow-right").hide();
    $("#mobile-close-arrow-left").click(function () {
      $("#mySidenav").css("width", "100px");
      $(".dashboard-main-section").css("margin-left", "100px");
      $(".dashboard-navbar-brand img").css("width", "50px");
      $(".dashboard-navbar-brand img").css("height", "50px");
      $("#mobile-close-arrow-left").hide();
      $(".dashboard-text-1").hide();
      $("#mobile-close-arrow-right").show();
    });
    $("#mobile-close-arrow-right").click(function () {
      $("#mySidenav").css("width", "250px");
      $(".dashboard-main-section").css("margin-left", "250px");
      $(".dashboard-navbar-brand img").css("width", "80px");
      $(".dashboard-navbar-brand img").css("height", "80px");
      $("#mobile-close-arrow-left").show();
      $(".dashboard-text-1").show();
      $("#mobile-close-arrow-right").hide();
    });

    if ($("#mySidenav").css("width") === "100px") {
      $("#mySidenav").css("a");
    }
  });

  const isObjectEmpty = (objectName) => {
    for (let prop in objectName) {
      if (objectName.hasOwnProperty(prop)) {
        return false;
      }
    }
    return true;
  };

  const renderContent = () => {

    if (location.pathname === "/user-Details") {
      return <UserDetails />;
    }
    if (location.pathname === "/Transaction-history") {
      return <TransactionHistory />;
    }
    if (location.pathname === "/kyc-status") {
      return <KycStatus />;
    }
    if (location.pathname === "/admin-settings") {
      return <AdminSettings />;
    }
    if (location.pathname === "/admin-manualtransfer-history") {
      return <AdminmanualTransferHistory />;
    }
    if (location.pathname === "/admin-transfer-history") {
      return <AdminHistory />;
    }
    if (location.pathname === "/userWallet-details") {
      return <UserWallet />;
    }
    if (location.pathname === "/referral-status") {
      return <ReferralStatus />;
    }
    if (location.pathname === "/Transaction-Admin-manual-coin") {
      return <Adminmanual />;
    }
    if (location.pathname === "/Kyc-details") {
      return <KYCdetails />;
    }
    if (location.pathname === "/Withdraw-request") {
      return <Withdrawrequest />;
    }
    if (location.pathname === "/Rewardranking") {
      return <Rewardranking />;
    }
    if (location.pathname === "/Plane-reward") {
      return <Planreward />;
    }
    if (location.pathname === "/admin-wallet") {
      return <Adminwallet />;
    }
    if (location.pathname === "/Claim-History") {
      return <ClaimHistory />;
    }
    if (location.pathname === "/user-stake-details") {
      return <Userstakedetails />;
    }
    // if (location.pathname === "/texa-wallet-transfer") {
    //   return <Texawallet />;
    // }
    // if (location.pathname === "/Restake-plan") {
    //   return <RestakePlan />;
    // }
    
    if (location.pathname === "/user-level-income-history") {
      return <Userincomehistory />;
    }
    if (location.pathname === "/view-history") {
      return <Viewhistory />;
    }
    if (location.pathname === "/restake-request") {
      return <RestakeRequest />;
    }
    if (location.pathname === "/transfer-wallet-request") {
      return <Usertransferwallet />;
    }
    if (location.pathname === "/admin-claim-history") {
      return <Adminclaimhistory />;
    }
    if (location.pathname === "/admin-referral") {
      return <AdminReferralStatus />;
    }

    return <Error />;
  };

  const logOut = () => {
    localStorage.clear();
    window.location.href = "/";
    // console.log("clicked");
  };

  return (
    
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div>
          <span id="mobile-three-line-collapse">&#9776;</span>
          <div className="dashboard-sidenav-section" id="mySidenav">
            <nav
              id="sidebar"
              className="col-md-3 col-lg-12 d-md-block sidebar component-navbar"
            >
              <div className="d-flex flex-row">
                <div className="ms-auto me-3">
                  <span id="mobile-close-collapse">
                    <GrClose />
                  </span>
                </div>
              </div>
              <div className="text-center component-heading">
                <img className="mb-3 render-img" src={render1}></img>
              </div>
              <div className="position-sticky">
                {/* {admin && !isObjectEmpty(admin) && ( */}
                <ul className="nav flex-column">

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/admin-wallet" ? "active" : ""
                        }`}
                      href="/admin-wallet"
                    >
                      <BiSolidUserDetail /> Admin wallet
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/admin-referral" ? "active" : ""
                        }`}
                      href="/admin-referral"
                    >
                      <SiInstatus /> Admin Referral
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/referral-status" ? "active" : ""
                        }`}
                      href="/referral-status"
                    >
                      <SiInstatus /> User Referral
                    </a>
                  </li>     

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Transaction-Admin-manual-coin" ? "active" : ""
                        }`}
                      href="/Transaction-Admin-manual-coin"
                    >
                      <TbHistoryToggle /> Admin manual coin update
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/user-Details" ? "active" : ""
                        }`}
                      href="/user-Details"
                    >
                      <BiSolidUserDetail /> User Details
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Kyc-details" ? "active" : ""
                        }`}
                      href="/Kyc-details"
                    >
                      <TbListDetails /> User Kyc-Details
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/userWallet-details" ? "active" : ""
                        }`}
                      href="/userWallet-details"
                    >
                      <SiWalletconnect /> User Wallet
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Rewardranking" ? "active" : ""
                        }`}
                      href="/Rewardranking"
                    >
                      <FaMedal /> User Reward
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/user-stake-details" ? "active" : ""
                        }`}
                      href="/user-stake-details"
                    >
                      <SiWalletconnect /> User Stake Details
                    </a>
                  </li>

                  

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Withdraw-request" ? "active" : ""
                        }`}
                      href="/Withdraw-request"
                    >
                      <FaCodePullRequest /> Withdraw Request
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/restake-request" ? "active" : ""
                        }`}
                      href="/restake-request"
                    >
                      <FaCodePullRequest /> Restake Request
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/transfer-wallet-request" ? "active" : ""
                        }`}
                      href="/transfer-wallet-request"
                    >
                      <FaCodePullRequest /> User  Wallet Transfer Request
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/admin-settings" ? "active" : ""
                        }`}
                      href="/admin-settings"
                    >
                      <GrUserSettings /> Admin Settings
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Plane-reward" ? "active" : ""
                        }`}
                      href="/Plane-reward"
                    >
                      <PiMedalMilitary /> Staking Plan
                    </a>
                  </li>


                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/admin-transfer-history" ? "active" : ""
                        }`}
                      href="/admin-transfer-history"
                    >
                      <BiTransfer /> Admin Transfer History
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/admin-manualtransfer-history" ? "active" : ""
                        }`}
                      href="/admin-manualtransfer-history"
                    >
                      <BiTransfer /> Admin Manual Transfer History
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/admin-claim-history" ? "active" : ""
                        }`}
                      href="/admin-claim-history"
                    >
                      <PiMedalMilitary />Admin Claim History
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Claim-History" ? "active" : ""
                        }`}
                      href="/Claim-History"
                    >
                      <PiMedalMilitary />User Claim History
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/user-level-income-history" ? "active" : ""
                        }`}
                      href="/user-level-income-history"
                    >
                      <BiTransfer /> User Level Income History
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Transaction-history" ? "active" : ""
                        }`}
                      href="/Transaction-history"
                    >
                      <MdManageHistory /> Transaction History
                    </a>
                  </li>

                  <li className="nav-item d-none">
                    <a
                      className={`nav-link ${location.pathname === "/view-history" ? "active" : ""
                        }`}
                      href="/view-history"
                    >
                      <BiTransfer />view History
                    </a>
                  </li>

                  {/* <li className="nav-item">
                    <a
                      className={`nav-link ${location.pathname === "/Restake-plan" ? "active" : ""
                        }`}
                      href="/Restake-plan"
                    >
                      <PiMedalMilitary /> Restake Plan
                    </a>
                  </li> */}

                  <li className="nav-item" style={{ cursor: "pointer" }}>
                    <a
                      className={`nav-link ${location.pathname === "/" ? "active" : ""
                        }`}
                      onClick={logOut}
                    >
                      <TbLogout /> Logout
                    </a>
                  </li>

                </ul>
                {/* )} */}
              </div>
            </nav>
          </div>
        </div>


        {/* Main Content ===> 2ND CHOICE */}
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          {/* {admin && !isObjectEmpty(admin) && renderContent()} */}
          {renderContent()}
        </main>
      </div>
    </div>
  );
}
export default SidebarLayout;